import api from '@/utils/api';
import config from '@/config';

const dashboardService = {
  // Get dashboard statistics
  getStatistics: async () => {
    return api.get(config.endpoints.dashboard.statistics);
  },
};

export default dashboardService;
